export const ZAEXBasicInfo = (data = {}) => {
  const v = (x) => (x === null || x === undefined || x === "" ? "-" : x);

  const rawItems = [
    ["GST Registered", data.GSTRegistration ? "Yes" : "No"],
    ["GST Reg. No.", v(data.GSTRegistrationNumber)],
    ["MSME Registered", data.MSMERegistration ? "Yes" : "No"],
    ["MSME Reg. No.", v(data.MSMERegistrationNumber)],
    ["Other Registration", v(data.Other)],
    ["Address Line 1", v(data.AddressLine1)],
    ["Address Line 2", v(data.AddressLine2)],
    ["Address Line 3", v(data.AddressLine3)],
    ["Address Line 4", v(data.AddressLine4)],
    ["City", v(data.City)],
    ["State", v(data.State)],
    ["Country", v(data.Country)],
    ["Pincode", v(data.Pincode)],
    ["Location", v(data.Location)],
    ["Contact First Name", v(data.ContactPersonFirstName)],
    ["Contact Last Name", v(data.ContactPersonLastName)],
    ["Contact Number", v(data.ContactNumber)],
    ["Email", v(data.Email)],
    ["Alt Contact Person", v(data.AlternateContactPersonName)],
    ["Alt Contact No.", v(data.AlternateContactNumber)],
    ["Alt Email", v(data.AlternateEmail)],
  ];

  const rows = [];
  for (let i = 0; i < rawItems.length; i += 2) {
    rows.push(rawItems.slice(i, i + 2));
  }

  return `
<h5>Basic Information</h5>

<style>
  .basic-table {
    width: 100%;
    border-collapse: collapse;
    page-break-inside: auto;
  }
  .basic-table tr {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .basic-table td {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .basic-table td div {
    page-break-inside: avoid;
    break-inside: avoid;
  }
  .basic-label {
    font-weight: 600;
    white-space: nowrap;
  }
</style>

<table class="basic-table">
  ${
    rows.length === 0
      ? `<tr><td colspan="4" style="text-align:center;">No Basic Information Available</td></tr>`
      : rows
          .map(
            (row) => `
            <tr>
              ${row
                .map(
                  ([label, value]) => `
                    <td class="basic-label"><div>${label}</div></td>
                    <td><div>${value}</div></td>
                  `
                )
                .join("")}
            </tr>
          `
          )
          .join("")
  }
</table>
`;
};